import styled from 'styled-components';
import { colors } from './theme';

export const Dropdown = styled.div`
  position: relative;

  &.tooltip-dropdown {
    .dropdown-menu {
      right: auto;
      left: 0;
      padding: 15px;
      transform: none;

      &:before {
        right: auto;
        left: 15px;
      }

      .check-list {
        li {
          margin-bottom: 12px;
        }
      }
    }
  }

  .dropdown-dots {
    display: block;
    cursor: pointer;
    width: 25px;
    height: 25px;
    text-align: center;
    margin-left: auto;

    span {
      background-color: #000;
      border-radius: 50%;
      position: relative;
      display: inline-block;
      width: 5px;
      height: 5px;
      &:before,
      &:after {
        position: absolute;
        left: -10px;
        width: 5px;
        height: 5px;
        background-color: #000;
        border-radius: 50%;
        top: 0;
        content: '';
      }

      &:after {
        left: auto;
        right: -10px;
      }
    }
  }

  &:not(.no-hover):hover {
    .dropdown-menu {
      opacity: 1;
      visibility: visible;
    }
  }

  .dropdown-menu {
    background-color: #fff;
    box-shadow: 0px -2.75px 18px rgba(0, 0, 0, 0.1);
    list-style-type: none;
    margin: 0;
    position: absolute;
    left: 100%;
    min-width: 120px;
    padding: 0;
    border-radius: 8px;
    transform: translateX(calc(-50% - 12px));
    transition: 0.4s ease;
    opacity: 0;
    visibility: hidden;
    z-index: 999;

    &:before {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid #fff;
      position: absolute;
      top: -5px;
      left: 0;
      right: 0;
      margin: 0 auto;
      content: '';
    }

    &.open {
      opacity: 1;
      visibility: visible;
    }

    li {
      margin: 0;

      a {
        font-size: 14px;
        padding: 10px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f7f7f7;

        img {
          margin-right: 6px;
        }

        &:hover {
          background-color: ${colors.lightgrey};
        }
      }

      &:last-child {
        a {
          border: none;
        }
      }
    }
  }
`;
export const PeopleImages = styled.div`
  display: flex;

  .single-person {
    position: relative;
    margin-left: -10px;

    &:first-child {
      margin-left: 0;
    }

    .person-name {
      position: absolute;
      background-color: ${colors.blue};
      color: #fff;
      padding: 4px;
      left: -50%;
      right: 0;
      min-width: 120px;
      border-radius: 6px;
      box-shadow: 0px 4px 4px rgba(221, 221, 221, 0.25);
      opacity: 0;
      visibility: hidden;
      transition: 0.3s ease;
      text-align: center;
    }

    &:hover {
      .person-name {
        opacity: 1;
        visibility: visible;
      }
    }

    .perosn-photo {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #fff;
      display: block;

      img {
        object-fit: cover;
        object-position: center;
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }
  .total-persons {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    line-height: 30px;
    box-shadow: 2.39493px 1.59662px 31.9324px rgba(0, 0, 0, 0.12);
    margin-left: -10px;
    position: relative;
    z-index: 1;
    display: block;
    background-color: #fff;
  }
`;

export const SelectWithIcon = styled.div`
  display: flex;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  padding-left: 8px;

  .icon-select {
    width: 100%;

    > div {
      border: none;
      box-shadow: none;
    }

    .css-1okebmr-indicatorSeparator {
      display: none;
    }
  }
`;
export const PersonDetail = styled.div`
  display: flex;
  align-items: center;

  h3 {
    font-size: 16px;
    margin: 0;
  }
  p {
    color: #b5b5b5;
    margin: 0;
  }
  .round-image {
    margin-right: 15px;
  }
`;
export const CustomCheckbox = styled.div`
  input[type='checkbox'] {
    display: none;
  }
  label {
    padding-left: 30px;
    position: relative;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 15px;
    cursor: pointer;

    &:before {
      position: absolute;
      width: 20px;
      height: 20px;
      border: 1px solid ${colors.darkgrey};
      left: 0;
      top: 5px;
      content: '';
      border-radius: 5px;
      transition: 0.3s ease;
    }
    &:after {
      position: absolute;
      width: 10px;
      height: 7px;
      background-image: url(/img/white-check.svg);
      background-repeat: no-repeat;
      background-size: contain;
      left: 6px;
      top: 12px;
      content: '';
      border-radius: 50%;
      transition: 0.3s ease;
      transform: scale(0);
    }
  }

  input[type='checkBox']:checked + label {
    &:before {
      border: 1px solid ${colors.blue};
      background-color: ${colors.blue};
    }
    &:after {
      transform: scale(1);
    }
  }
`;
export const CustomRadio = styled.div`
  input[type='radio'] {
    display: none;
  }

  label {
    padding-left: 38px;
    position: relative;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;

    &:before {
      position: absolute;
      width: 24px;
      height: 24px;
      border: 1px solid ${colors.darkgrey};
      left: 0;
      top: 5px;
      content: '';
      border-radius: 50%;
      transition: 0.3s ease;
    }
    &:after {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: ${colors.blue};
      left: 7px;
      top: 12px;
      content: '';
      border-radius: 50%;
      transition: 0.3s ease;
      transform: scale(0);
    }
  }

  input[type='radio']:checked + label {
    &:before {
      border: 1px solid ${colors.blue};
    }
    &:after {
      transform: scale(1);
    }
  }
`;
export const CustomUploadFile = styled.div`
  .img-placeholder {
    border-radius: 50%;
    overflow: hidden;
    width: 85px;
    height: 85px;
    margin-right: 22px;

    img {
      object-fit: cover;
      object-position: center;
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .upload-file-input {
    margin-top: 15px;
    .custom-file-upload-button {
      appearance: none;
      -webkit-appearance: none;
      opacity: 0;
      cursor: pointer;
      position: relative;
      z-index: 99;
      height: 55px;
      display: inline-block;
      vertical-align: top;
      width: 140px;

      &:hover + .button {
        background-color: ${colors.blue};
        color: #fff;
      }
    }
    span.button {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .url-input-box {
    position: absolute;
    background-color: #fff;
    padding: 12px 15px;
    box-shadow: 0px 4px 4px rgba(221, 221, 221, 0.25);
    border-radius: 4px;
    top: 45px;
    left: 10px;
    width: 284px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    transition: 0.4s ease;

    .form-control {
      height: 34px;
      padding: 5px;
      border-radius: 4px;
      font-size: 14px;
      color: ${colors.text};
    }

    &.show {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }

  .link-button {
    border: none;
    background-color: transparent;
    position: relative;

    .cross-img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      bottom: 0;
      opacity: 0;
      transform: rotateZ(-90deg);
      transition: 0.3s ease;
    }
    .link-img {
      transform: rotateZ(0);
      transition: 0.3s ease;
      opacity: 1;
    }

    &.active {
      .link-img {
        opacity: 0;
        transform: rotateZ(90deg);
      }
      .cross-img {
        transform: rotateZ(0);
        opacity: 1;
      }
    }
  }
`;

export const VerticalPriceBox = styled.div`
  padding: 30px 40px;
  text-align: center;

  p {
    margin-bottom: 10px;
  }
  .plan-name {
    font-size: 24px;
    line-height: 32px;
    color: #0e64ff;
  }
  .price {
    font-size: 48px;
    font-weight: 400;
    line-height: 56px;
    margin: 0;

    span {
      font-size: 24px;
      letter-spacing: -0.5px;
      color: rgba(0, 0, 0, 0.4);
      line-height: 32px;
    }
  }
  .button {
    margin: 25px 0 45px;
  }
  .plan-feature-list {
    text-align: left;

    li {
      font-size: 16px;
    }
  }
`;

export const Breadcrum = styled.div`
  margin-bottom: 50px;
  a {
    display: inline-block;
    padding-right: 25px;
    position: relative;
    color: #959595;

    &:first-child {
      color: ${colors.black};
    }

    &:last-child {
      padding: 0;
      pointer-events: none;

      &:after {
        display: none;
      }
    }

    &:hover {
      color: ${colors.blue};
    }

    &:after {
      background-image: url(/img/chevron-down.svg);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      position: absolute;
      right: 7px;
      content: '';
      width: 8px;
      height: 8px;
      transform: rotateZ(-90deg);
      top: 6px;
      opacity: 0.4;
    }
  }
`;

export const Tooltip = styled.div`
  position: relative;

  .tooltip-text {
    position: absolute;
    width: 130px;
    left: 50%;
    transform: translate(-50%, 70%);
    bottom: -100%;
    width: auto;
    padding: 8px 12px;
    background-color: #0b2b84;
    white-space: nowrap;
    font-size: 12px;
    border-radius: 7px;
    color: #fff;
    transition: 0.3s ease;
    opacity: 0;
    visibility: hidden;

    &:before {
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #0b2b84;
      content: '';
    }
  }

  &:hover {
    .tooltip-text {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const AccordionBlock = styled.div`
  background-color: #fff;
  padding: 22px 25px;
  border-radius: 8px;
  box-shadow: 0px 4px 4px rgba(221, 221, 221, 0.5);
  margin-bottom: 22px;

  &.active {
    .accordion-body {
      max-height: max-content;
      animation: fadeIn 0.5s ease 1 forwards;
    }

    .accordion-head {
      pointer-events: none;
    }
  }

  .accordion-head {
    display: flex;
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: left;

    h3 {
      font-size: 16px;
      line-height: 26px;
      margin: 0;
      font-weight: 600;
      flex: 1;

      .tag {
        margin-left: 8px;
      }
    }
  }

  .accordion-body {
    max-height: 0;
    overflow: hidden;
  }
`;
